module.exports = __webpack_public_path__ + "static/media/teaser-darknet.8c64495d.jpg";